import axios from '@!/lib/axios'
import { getCsrfToken } from '@!/Util/postRequest'

export const purchaseCoinWithCreditApi = async ({ listIndex, apiTime }) => {
  return await axios.post(
    '/api/v1/purchase/coin/pay_with_credit',
    {
      list_index: listIndex,
      current_time: apiTime,
    },
    {
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': getCsrfToken(),
      },
    },
  )
}

export const purchaseCoinWithCarrierApi = async ({ listIndex, apiTime, carrier }) => {
  return await axios.post(
    '/api/v1/purchase/coin/pay_with_carrier',
    {
      list_index: listIndex,
      current_time: apiTime,
      carrier: carrier,
    },
    {
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': getCsrfToken(),
      },
    },
  )
}

export const purchaseCoinWithPaypayApi = async ({ listIndex, apiTime }) => {
  return await axios.post(
    '/api/v1/purchase/coin/pay_with_paypay',
    {
      list_index: listIndex,
      current_time: apiTime,
    },
    {
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': getCsrfToken(),
      },
    },
  )
}
